"use client";

import { useCallback, useState, useRef } from "react";

import Confirm from "../components/dialog/Confirm";

/**
 * 確認ダイアログを表示するための拡張カスタムフック
 * useConfirmのラッパーとして機能し、追加の機能を提供します
 * @returns {Object} 確認ダイアログ操作のメソッド
 */
export function useConfirmEx() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("primary");
  const resolvePromiseRef = useRef(null);

  const showConfirm = useCallback((message, option = {}) => {
    return new Promise((resolve) => {
      setMessage(message);
      setColor(option.color || "primary");
      resolvePromiseRef.current = resolve;
      setIsOpen(true);
    });
  }, []);

  const onResolve = useCallback((buttonType) => {
    setIsOpen(false);
    if (resolvePromiseRef.current) {
      resolvePromiseRef.current(buttonType);
      resolvePromiseRef.current = null;
    }
  }, []);

  const renderConfirmDialog = useCallback(() => {
    if (!isOpen) return null;
    return <Confirm isOpen={isOpen} message={message} color={color} onResolve={onResolve} />;
  }, [isOpen, message, color, onResolve]);

  return { showConfirm, renderConfirmDialog };
}
